import { DECEASED_TAB_NO } from './common/constants';
import { ICintorinConfig } from './common/interfaces';
import './style/search.scss';
import "./quickSearch.ts";
import { Tooltip } from 'bootstrap';
import { getGTagSearchPayload, getGTagSearchMoreResultsPayload } from './googleAnalytics';

declare const CintorinConfig: ICintorinConfig;

declare var CintorinKarta: {
    updateGraveCard:(hId: number | "none", cId: number, selectedTabIndex?: number, zId?: number) => Promise<void>
    updateCemeteryData:(cid?: number) => void
};

declare var CintorinMapa: {
    selectGrave:(locationId: string, cintorinId:number) => void
    setMap: (id: number) => void
};

declare var CintorinIAM: {
    addAuthorization:(headers: Headers) => Headers, 
    isLoggedIn:() => boolean
}

var simpleSearchTooltip: Tooltip, advancedSearchTooltip: Tooltip;

document.addEventListener("readystatechange", () => {
    if (document.readyState === 'complete') {
        let buttons = document.getElementsByClassName("dismiss-button");
        for (let i = 0; i < buttons.length; i++) {
            let element = buttons[i] as HTMLSpanElement;
            element.addEventListener("click", handleDismissInputClick);
            let input = getRelevantInput(element);
            input.addEventListener("change", handleInputChange);
            updateButtonState(element, input);
        }
        let yearShortcuts = document.querySelectorAll("#datumUmrtiaHeader a");
        for (let i = 0; i < yearShortcuts.length; i++) {
            let anchor = yearShortcuts[i] as HTMLAnchorElement;
            anchor.addEventListener("click", handleYearShortcutClicked);
        }
        let dateDismissButtons = document.querySelectorAll("span.dismiss-dates");
        for (let i = 0; i < dateDismissButtons.length; i++) {
            dateDismissButtons[i].addEventListener("click", handleDismissDatesSpanClick);
        }
        let searchType = (document.getElementById("cintoriny_typ") as HTMLInputElement).value;
        if (+searchType > 0) { // vyhladavanie pamatnikov
            document.getElementById("citySearch").addEventListener("keydown", getSearchKeyDownHandler(monumentSearch));
            document.getElementById("monumentSearchButton").addEventListener("click", getSearchButtonClickHandler(monumentSearch));
        } else { // defaultne vyhladavanie
            document.getElementById("advancedSearchToggle").addEventListener("click", handleShowAdvancedSearchClicked);
            document.getElementById("simpleSearchToggle").addEventListener("click", handleHideAdvancedSearchClicked);
            simpleSearchTooltip = new Tooltip(document.getElementById("simpleSearchToggle"), {trigger: "manual"});
            advancedSearchTooltip = new Tooltip(document.getElementById("advancedSearchToggle"), {trigger: "manual"});
            document.getElementById("simpleSearchToggle").addEventListener("pointerenter", () => {simpleSearchTooltip?.show();});
            document.getElementById("simpleSearchToggle").addEventListener("pointerleave", () => {simpleSearchTooltip?.hide();});
            document.getElementById("advancedSearchToggle").addEventListener("pointerenter", () => {advancedSearchTooltip?.show();});
            document.getElementById("advancedSearchToggle").addEventListener("pointerleave", () => {advancedSearchTooltip?.hide();});

            document.getElementById("simpleSearchButton").addEventListener("click", getSearchButtonClickHandler(search));
            document.getElementById("advancedSearchButton").addEventListener("click", getSearchButtonClickHandler(search));

            document.getElementById("datumNarodeniaOd").addEventListener("input", handleDateValueChanged);
            document.getElementById("datumNarodeniaDo").addEventListener("input", handleDateValueChanged);
            document.getElementById("datumUmrtiaOd").addEventListener("input", handleDateValueChanged);
            document.getElementById("datumUmrtiaDo").addEventListener("input", handleDateValueChanged);
            document.getElementById("obec").addEventListener("input", handleSearchTermsChanged);
            document.getElementById("obec").addEventListener("keydown", getSearchKeyDownHandler(search));
            document.getElementById("priezvisko").addEventListener("input", handleSearchTermsChanged);
            document.getElementById("priezvisko").addEventListener("keydown", getSearchKeyDownHandler(search));
            document.getElementById("rodnePriezvisko").addEventListener("input", handleSearchTermsChanged);
            document.getElementById("rodnePriezvisko").addEventListener("keydown", getSearchKeyDownHandler(search));
            document.getElementById("meno").addEventListener("input", handleSearchTermsChanged);
            document.getElementById("meno").addEventListener("keydown", getSearchKeyDownHandler(search));
            document.getElementById("datumNarodeniaOd").addEventListener("input", handleSearchTermsChanged);
            document.getElementById("datumNarodeniaDo").addEventListener("input", handleSearchTermsChanged);
            document.getElementById("datumUmrtiaOd").addEventListener("input", handleSearchTermsChanged);
            document.getElementById("datumUmrtiaDo").addEventListener("input", handleSearchTermsChanged);
            document.getElementById("sektor").addEventListener("input", handleSearchTermsChanged);
            document.getElementById("sektor").addEventListener("keydown", getSearchKeyDownHandler(search));
            document.getElementById("rad").addEventListener("input", handleSearchTermsChanged);
            document.getElementById("rad").addEventListener("keydown", getSearchKeyDownHandler(search));
            document.getElementById("cislo").addEventListener("input", handleSearchTermsChanged);
            document.getElementById("cislo").addEventListener("keydown", getSearchKeyDownHandler(search));
            attachResultEventHandlers(document.getElementById("actualSearchResults"));
        }

        let searchPayload = document.getElementById("searchPayload") as HTMLInputElement;
        if (searchPayload && searchPayload.value) {
            search();
        }
    }
});

function handleDismissInputClick() {
    let input = getRelevantInput(this as any);
    if (input && input.value != "") {
        input.value = "";
        updateButtonState(this as any, input);
        handleSearchTermsChanged();
        input.dispatchEvent(new MouseEvent("input"));
    } else if (input) {
        input.focus();
        input.dispatchEvent(new FocusEvent("focusin"));
    }
}

function handleDismissDatesSpanClick() {
    let relevantId = this.getAttribute("data-dismiss-target");
    const suffixes = ["Od", "Do"];
    if (relevantId != "") {
        suffixes.map(id => {
            let input = document.getElementById(relevantId+id) as HTMLInputElement;
            if (input && input.value) {
                input.value = "";
                handleSearchTermsChanged();
            }
        });
    }
    this.innerText = "";
}

function handleInputChange() {
    let span = this.parentElement.parentElement.querySelector("span.dismiss-button") as HTMLSpanElement;
    updateButtonState(span, this as any);
}

function handleHideAdvancedSearchClicked() {
    document.getElementById("advanced-search").classList.add("karta-collapsed");
    document.getElementById("simpleSearchToggle").parentElement.classList.add("karta-collapsed");
    document.getElementById("advancedSearchTitle").classList.add("karta-collapsed");
    document.getElementById("simpleSearchTitle").classList.remove("karta-collapsed");
    document.getElementById("advancedSearchToggle").parentElement.classList.remove("karta-collapsed");
    // clear search values
    (document.getElementById("datumNarodeniaOd") as HTMLInputElement).value = "";
    (document.getElementById("datumNarodeniaDo") as HTMLInputElement).value = "";
    (document.getElementById("datumUmrtiaOd") as HTMLInputElement).value = "";
    (document.getElementById("datumUmrtiaDo") as HTMLInputElement).value = "";
    (document.getElementById("sektor") as HTMLInputElement).value = "";
    (document.getElementById("rad") as HTMLInputElement).value = "";
    (document.getElementById("cislo") as HTMLInputElement).value = "";
    handleSearchTermsChanged();
}

function handleShowAdvancedSearchClicked() {
    document.getElementById("advancedSearchToggle").parentElement.classList.add("karta-collapsed");
    document.getElementById("simpleSearchTitle").classList.add("karta-collapsed");
    document.getElementById("advancedSearchTitle").classList.remove("karta-collapsed");
    document.getElementById("simpleSearchToggle").parentElement.classList.remove("karta-collapsed");
    document.getElementById("advanced-search").classList.remove("karta-collapsed");
}

function handleYearShortcutClicked() {
    let from = (document.getElementById("datumUmrtiaOd") as HTMLInputElement);
    from.value = this.innerText+"-01-01";
    from.classList.remove("highlight");
    void from.offsetWidth; // hack aby sa spustila animacia https://css-tricks.com/restart-css-animation/#aa-update-another-javascript-method-to-restart-a-css-animation
    from.classList.add("highlight");
    let to = (document.getElementById("datumUmrtiaDo") as HTMLInputElement);
    to.value = this.innerText+"-12-31";
    to.classList.remove("highlight");
    void to.offsetWidth; // hack aby sa spustila animacia
    to.classList.add("highlight");
    handleDateValueChanged();
    handleSearchTermsChanged();
}

function handleSearchResultLinkClicked(e: MouseEvent) {
    e.stopPropagation();
    if (this.hasAttribute("data-cemetery-id")) {
        let cid = +this.getAttribute("data-cemetery-id");
        gtag("event", "searchResultClicked", {
            clickedCid: cid,
            searchTarget: "cemetery"
        });
        CintorinKarta.updateCemeteryData(cid);
        CintorinKarta.updateGraveCard("none", cid);
        CintorinMapa.setMap(cid);
        updateHistoryWithAdditionalParameters({
            "cintorinId": cid+"",
        });
        if (document.getElementById("mapContainer")) {
            document.getElementById("mapContainer").scrollIntoView({behavior: "smooth"});
        }
    } else if (this.hasAttribute("data-grave-id")) {
        let hId = this.getAttribute("data-grave-id");
        let cId = Math.floor(+hId / 1000000);
        let zId = this.getAttribute("data-deceased-id");
        gtag("event", "searchResultClicked", {
            clickedCid: cId,
            searchTarget: "grave"
        });
        CintorinKarta.updateCemeteryData(cId);
        CintorinKarta.updateGraveCard(hId, cId, DECEASED_TAB_NO, zId).then(function () {
            if (document.getElementById("cardIdentifier")){
                CintorinMapa.selectGrave((document.getElementById("cardIdentifier") as HTMLInputElement).value, cId);
            }
        });
        // todo: prerobit to idealne tak aby boli v mape rovno ID hrobov
        updateHistoryWithAdditionalParameters({
            "cintorinId": cId+"",
            "hrobId": hId+"",
            "zosnulyId": zId+""
        });
    }
}

function handleSearchResultListItemClicked() {
    let li = this.parentElement as HTMLLIElement;
    if (li.classList.contains("last")){
        return;
    }
    if (li.classList.contains("category-collapsed")) {
        li.classList.remove("category-collapsed");
    } else {
        li.classList.add("category-collapsed");
    }
}

function handleDateValueChanged() {
    (document.querySelector("span[data-dismiss-target=datumNarodenia]") as HTMLElement).innerText = 
        ((document.getElementById("datumNarodeniaOd") as HTMLInputElement).value != ""
            || (document.getElementById("datumNarodeniaDo") as HTMLInputElement).value != "")? "╳" : "";
    (document.querySelector("span[data-dismiss-target=datumUmrtia]") as HTMLElement).innerText = 
        ((document.getElementById("datumUmrtiaOd") as HTMLInputElement).value != ""
            || (document.getElementById("datumUmrtiaDo") as HTMLInputElement).value != "")? "╳" : "";
}

function handleSearchTermsChanged() {
    if (document.getElementById("searchPayload")) {
        let reference = (document.getElementById("searchPayload") as HTMLInputElement).value;
        let current = getSearchPayload().join("&");
        if (reference != current) {
            document.getElementById("searchResultsContainer").classList.add("karta-collapsed");
            document.getElementById("carouselContainer").classList.remove("karta-collapsed");
        }
        if (CintorinMapa.setMap)
            CintorinMapa.setMap(undefined);
        if (CintorinKarta.updateCemeteryData) 
            CintorinKarta.updateCemeteryData(undefined);
        if (CintorinKarta.updateGraveCard) 
            CintorinKarta.updateGraveCard('none', undefined);
    }
}

function getSearchButtonClickHandler(action: ()=>void) {
    return function (e: MouseEvent) {
        e.preventDefault();
        action();
    }
}

function getSearchKeyDownHandler(action: () => void) {
    return function (event :KeyboardEvent) {
        if (event.key == "Enter")  {
            action();
            event.preventDefault();
        }
    }
}

function updateButtonState(span:HTMLSpanElement, input:HTMLInputElement) {
    if (input) {
        span.innerText = (input.value != "") ? "╳" : "";
    }
}

function getRelevantInput(span:HTMLSpanElement) {
    return span.parentElement.querySelector("input[type=text]") as HTMLInputElement;
}

function attachResultEventHandlers(resultDiv: HTMLElement) {
    let links = resultDiv.querySelectorAll("a");
    links.forEach(a => a.addEventListener("click", handleSearchResultLinkClicked));
    let listItems = resultDiv.querySelectorAll("li:not(.last)>div:first-child");
    listItems.forEach(div => div.addEventListener("click", handleSearchResultListItemClicked));
    let moreData = resultDiv.querySelectorAll(".more-rows");
    moreData.forEach(div => div.addEventListener("click", loadMoreResults));
}

function monumentSearch() {
    let cintoriny_typ = (document.getElementById("cintoriny_typ") as HTMLInputElement).value;
    let searchTerm = (document.getElementById("citySearch") as HTMLInputElement).value;
    location.href='index.php?search=pamatnik&cintoriny_typ='+cintoriny_typ+'&citySearch='+searchTerm;
}

function search() {
    let payload = getSearchPayload();
    let hasCity = payload.find(s => s.startsWith("cemeteryId=") || (s.startsWith("city=") && (s.split("=")[1].length > 0)));
    let hasSurname = payload.find(s => (s.startsWith("surname=") || s.startsWith("maidenSurname=")) && (s.split("=")[1].length > 0));
    let hasName = payload.find(s => s.startsWith("name=") && (s.split("=")[1].length > 0));
    let hasAdvancedCriteria = payload.find(s => !s.startsWith("cemeteryId=") && !s.startsWith("city=") && !s.startsWith("surname=") && !s.startsWith("maidenSurname=") && !s.startsWith("name=") && (s.split("=")[1].length > 0));

    if (CintorinIAM.isLoggedIn()) {
        if (!hasName && !hasSurname && !hasCity && !hasAdvancedCriteria) {
            window.alert("Pre vyhľadávanie uveďte aspoň jedno kritérium pre vyhľadávanie");
            return;
        }
    } else if (!hasAdvancedCriteria && !hasCity) {
        hasSurname = payload.find(s => (s.startsWith("surname=") || s.startsWith("maidenSurname=")) && (s.split("=")[1].length > 1));
        if (!hasName) {
            window.alert('Pre vyhľadávanie uveďte minimálne:\n- prvé písmeno názvu obce/mesta alebo cintorína (bez mena zosnulého),\nalebo\n- prvé písmeno názvu obce/mesta alebo cintorína a prvé dve písmená priezviska zosnulého,\nalebo\n- prvé dve písmená priezviska a prvé písmeno mena zosnulého.');
            return;
        } else if (hasName && !hasSurname) {
            window.alert('Vyhľadávať podľa mena zosnulého možno len v kombinácii s aspoň dvoma prvými písmenami priezviska. Kombinácia dovoľuje pridať aj názov obce/mesta alebo cintorína.');
            return;
        } 
    }

    let actualResults = document.getElementById("actualSearchResults");
    let loadingDiv = document.getElementById("searchResultsLoadingDiv");
    document.getElementById("carouselContainer").classList.add("karta-collapsed");
    actualResults.classList.add("karta-collapsed");
    loadingDiv.classList.remove("karta-collapsed");
    document.getElementById("searchResultsContainer").classList.remove("karta-collapsed");

    let urlBase = hasAdvancedCriteria ? "?advancedSearch&type=" : "?simpleSearch&type=";
    history.pushState(null, '', window.location.pathname + urlBase+(document.getElementById("type") as HTMLInputElement).value+"&" + payload.join("&"));

    let request = {
        method: "POST",
        headers: CintorinIAM.addAuthorization(new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        })),
        body: payload.join("&")
    };

    gtag("event", "searchTriggered", getGTagSearchPayload());

    fetch(CintorinConfig.baseUrl+"/api/htmlSearch.php", request)
    .then(response => {
        if (response.ok) {
            return response.text();
        }
    }).then(content => {
        actualResults.innerHTML = content;
        attachResultEventHandlers(actualResults);
        loadingDiv.classList.add("karta-collapsed");
        actualResults.classList.remove("karta-collapsed");
        if (document.getElementById("simpleSearchResultsTitle")) {
            if (hasAdvancedCriteria) {
                document.getElementById("simpleSearchResultsTitle").classList.add("karta-collapsed");
            } else {
                document.getElementById("simpleSearchResultsTitle").classList.remove("karta-collapsed");
            }
        }
        if (document.getElementById("advancedSearchResultsTitle")) {
            if (hasAdvancedCriteria) {
                document.getElementById("advancedSearchResultsTitle").classList.remove("karta-collapsed");
            } else {
                document.getElementById("advancedSearchResultsTitle").classList.add("karta-collapsed");
            }
        }
        let quickLoadElement = document.getElementById("quickLoadId") as HTMLInputElement;
        if (quickLoadElement && quickLoadElement.value) {
            let cid = +quickLoadElement.value;
            CintorinKarta.updateCemeteryData(cid);
            CintorinKarta.updateGraveCard("none", cid);
            CintorinMapa.setMap(cid);
            updateHistoryWithAdditionalParameters({
                "cintorinId": cid+"",
            });
            if (document.getElementById("mapContainer")) {
                document.getElementById("mapContainer").scrollIntoView({behavior: "smooth"});
            }    
        }
    });
}

function loadMoreResults() {
    let nextId = this.getAttribute("data-from-id");
    let cid = this.getAttribute("data-cemetery-id");
    if (!nextId || !cid) {
        return;
    }

    let payload = getSearchPayload();
    payload.push("subsetFrom="+nextId);
    let cemeteryIndex = payload.findIndex(s => s.startsWith("cemeteryId="));
    if (cemeteryIndex == -1) {
        payload.push("cemeteryId="+cid);
    } else {
        payload[cemeteryIndex] = "cemeteryId="+cid;
    }

    this.innerText = ".";
    let animationInterval = setInterval(animateLoadingAdditionalData, 200, this);

    let request = {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: payload.join("&")
    };
    gtag("event", "searchMoreResultsRequested", getGTagSearchMoreResultsPayload(this));
    fetch(
        CintorinConfig.baseUrl+"/api/htmlSearch.php", 
        request)
    .then(response => {
        clearInterval(animationInterval);
        if (response.ok) {
            return response.text();
        }
    })
    .then(text => {
        if (text) {
            let parser = document.createElement("div");
            parser.innerHTML = text;
            attachResultEventHandlers(parser);
            let parent = this.parentElement;
            this.remove();
            Array.from(parser.children).map(t => parent.append(t));
        }
    })
}

function animateLoadingAdditionalData(context:HTMLElement) {
    let currentText = context.innerText;
    switch (currentText) {
        case ".":
            context.innerText = "..";
            break;
        case "..":
            context.innerText = "...";
            break;
        default:
            context.innerText = ".";
    }
}

function updateHistoryWithAdditionalParameters(parameters: {[key:string]:string}) {
    let query = new URLSearchParams(window.location.search);
    Object.keys(parameters).map(key => query.set(key, parameters[key]));
    let url = window.location.pathname + "?" + query.toString();
    history.pushState(null, '', url);
}

function getSearchPayload():string[] {
    let payload:string[] = [];

    let cityInput = document.querySelector("input#obec") as HTMLInputElement;
    if (cityInput.getAttribute("data-cemetery-id")) {
        payload.push("cemeteryId="+cityInput.getAttribute("data-cemetery-id"))
    } else {
        addTrimmedValue(payload, "input#obec", "city");
    }
    addTrimmedValue(payload, "input#priezvisko", "surname");
    addTrimmedValue(payload, "input#rodnePriezvisko", "maidenSurname");
    addTrimmedValue(payload, "input#meno", "name");
    addTrimmedValue(payload, "input#sektor", "section");
    addTrimmedValue(payload, "input#rad", "way");
    addTrimmedValue(payload, "input#cislo", "number");
    addTrimmedValue(payload, "input#datumNarodeniaOd", "birthDateFrom");
    addTrimmedValue(payload, "input#datumNarodeniaDo", "birthDateTo");
    addTrimmedValue(payload, "input#datumUmrtiaOd", "deathDateFrom");
    addTrimmedValue(payload, "input#datumUmrtiaDo", "deathDateTo");

    return payload;
}

function addTrimmedValue(array: string[], elementId: string, attributeName: string) {
    let input = document.querySelector(elementId) as HTMLInputElement;
    if (input.value.trim()) {
        array.push(attributeName+"="+encodeURIComponent(input.value.trim()));
    }
}